import { ReferAFriendLabels } from './refer-a-friend-labels.model';

// interfaces
export interface IReferAFriendLabelsPayload {
  referAFriendLabels: ReferAFriendLabels;
}

export interface IEmailPayload {
  email: string;
}

export interface IErrorPayload {
  error: any[];
}

export enum ActionsEnum {
  FETCH_LABELS = 'FETCH_LABELS',
  FETCH_LABELS_SUCCESS = 'FETCH_LABELS_SUCCESS',
  FETCH_LABELS_ERROR = 'FETCH_LABELS_ERROR',
  SEND_EMAIL = 'SEND_EMAIL',
  SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS',
  SEND_EMAIL_ERROR = 'SEND_EMAIL_ERROR',
}

// action payload
export interface FetchLabels {
  type: ActionsEnum.FETCH_LABELS;
}

export interface FetchLabelsSuccess {
  type: ActionsEnum.FETCH_LABELS_SUCCESS;
  payload: IReferAFriendLabelsPayload;
}

export interface FetchLabelsError {
  type: ActionsEnum.FETCH_LABELS_ERROR;
  payload: IErrorPayload;
}

export interface SendEmail {
  type: ActionsEnum.SEND_EMAIL;
  payload: IEmailPayload;
}

export interface SendEmailSuccess {
  type: ActionsEnum.SEND_EMAIL_SUCCESS;
  payload: IEmailPayload;
}

export interface SendEmailError {
  type: ActionsEnum.SEND_EMAIL_ERROR;
  payload: IErrorPayload;
}

// action creators
export const fetchLabels = (): FetchLabels => ({
  type: ActionsEnum.FETCH_LABELS,
});

export const fetchLabelsSuccess = (
  referAFriendLabels: ReferAFriendLabels
): FetchLabelsSuccess => ({
  type: ActionsEnum.FETCH_LABELS_SUCCESS,
  payload: {
    referAFriendLabels,
  },
});

export const fetchLabelsError = (error: any[]): FetchLabelsError => ({
  type: ActionsEnum.FETCH_LABELS_ERROR,
  payload: {
    error,
  },
});

export const sendEmail = (email: string): SendEmail => ({
  type: ActionsEnum.SEND_EMAIL,
  payload: {
    email,
  },
});

export const sendEmailSuccess = (email: string): SendEmailSuccess => ({
  type: ActionsEnum.SEND_EMAIL_SUCCESS,
  payload: {
    email,
  },
});

export const sendEmailError = (error: any[]): SendEmailError => ({
  type: ActionsEnum.SEND_EMAIL_ERROR,
  payload: {
    error,
  },
});
